import * as React from 'react';

import {Body} from '../typography/body';

import styles from './funnel-chart.module.css';

type Props = {
    delta: string;
};

export const FunnelDelta = (props: Props) => {
    return (
        <div className={styles['funnel-delta']}>
            <Body color='green' isBold={true} size='large'>
                {props.delta}
            </Body>
        </div>
    );
};
